/**
 * Tab configuration for OnboardingForm
 * Centralized configuration makes adding/removing tabs trivial
 */

import BorrowerBizProfile from "../BizProfile/BorrowerBizProfile";
import BorrowerRep from "../BorrowerRep/BorrowerRep";
import BorrowerBank from "../BorrowerBank/BorrowerBank";
import BorrowerDocsUpload from "../DocUpload/BorrowerDoc";
import { TabConfig } from "./types";

/**
 * Tab configuration array
 * Each tab is configured with its component and requirements
 */
export const TAB_CONFIGS: TabConfig[] = [
  {
    value: "business-profile",
    label: "Business Profile",
    component: BorrowerBizProfile,
  },
  {
    value: "representative",
    label: "Representative",
    component: BorrowerRep,
    requiresEmail: true,
  },
  {
    value: "bank-details",
    label: "Bank Details",
    component: BorrowerBank,
  },
  {
    value: "documents",
    label: "Documents",
    component: BorrowerDocsUpload,
    requiresOnboardingStatus: true,
  },
];

/**
 * Get initial dirty state object from tab configs
 */
export const getInitialDirtyState = (): { [key: string]: boolean } => {
  return TAB_CONFIGS.reduce((acc, tab) => ({ ...acc, [tab.value]: false }), {});
};
